import React from "react";
import { HealthOperationsIcon } from "../utils/healthUtils";

const DashboardHeader = ({ 
  mode, 
  marketCode, 
  marketName, 
  accountId, 
  onBackClick,
  onMarketDashboardClick,
  showOperationalHealth
}) => {
  return (
    <div className="dashboard-header-wrapper">
      {/* The row is always present so the header height does not change between
          views; only the button inside it is conditional. Rendering it just in
          market mode shifted everything below by its height on every switch. */}
      {!showOperationalHealth && (
        <div className="dashboard-back-container">
          {mode === 'market' && (
            <button
              className="dashboard-back-button"
              onClick={onBackClick}
              aria-label="Back to Global Dashboard"
            >
              <span>←</span> Back to Global
            </button>
          )}
        </div>
      )}

      <div className="dashboard-header">
        <div className="dashboard-header-left">
          <div className="health-section">
            <HealthOperationsIcon size={20} />
            <h3 className="health-title">Health Operations</h3>
          </div>
        </div>

        <div className="vertical-divider"></div>

        <div className="dashboard-header-right">
          <div className="dashboard-header-content">
            <div>
              <h3 className="health-title">
                {mode === 'global' ? marketName : `${marketName} (${marketCode})`}
              </h3>
              <p className="dashboard-overview-subtitle">
                {mode === 'global' 
                  ? 'Real-time platform health across all markets'
                  : `Real-time platform health for ${marketName}`
                }
              </p>
            </div>
            
            {/* Market Dashboard Button - Only in Market Mode */}
            {mode === "market" && !showOperationalHealth && (
              <button
                className="dashboard-btn"
                onClick={onMarketDashboardClick}
              >
                Market Dashboard
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;